import {Component, Input} from '@angular/core';
import {BrRegionalWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-regionalwetter-bericht',
  templateUrl: './br-regionalwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrRegionalwetterBerichtComponent {
  @Input() regionalWetterbericht: BrRegionalWetterbericht;
}
